import { CommonFunctions } from '../static/common-functions';
import { OrderService } from '../services/order.service';
import { Subscription } from 'rxjs';
import { AttachmentBus } from "./AttachmentBus";
import { v_InvoiceEquipmentBus } from './v_InvoiceEquipmentBus';
import { BasePage } from './BasePage';
import { DQOIErrorBus } from './DQOIError';
import { StatusHistoryBus } from './StatusHistoryBus';
import { OrderNotesBus } from './OrderNotesBus';

export class OrderPage extends BasePage<OrderService>
{
    svc_data: OrderService;
    constructor(svc_data: OrderService, data: OrderPage = null)
  {
      super();
    this.svc_data = svc_data;
    if (data !== null) {
//      this.dispatchId = data.dispatchId;
    }
  }

 clear() {
     this.unsubscribe();
     this.id = null;
     this.statusHistory = null;
     this.attachments = null;
     this.errors = null;
     this.notes = null;
     this.attachmentsLoading = false;
     this.errorsLoading = false;
     this.notesLoading = false;
     this.statusHistoryLoading = false;
 }
  unsubscribe() {
      CommonFunctions.unsubscribe(this.subs_statusHistory);
    CommonFunctions.unsubscribe(this.subs_attachments);
    CommonFunctions.unsubscribe(this.subs_errors);
      CommonFunctions.unsubscribe(this.subs_notes);
  }

  subs_attachments: Subscription;
    subs_errors: Subscription;
    subs_notes: Subscription;
  subs_statusHistory: Subscription;
  
    getAttachments(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            if (this.svc_data) {
                this.attachmentsLoading = true;
                CommonFunctions.unsubscribe(this.subs_attachments);
                this.subs_attachments = this.svc_data.getAttachments(id).subscribe(data => {
                    let att = [];
                    if (CommonFunctions.hasArrayValue(data)) {
                        for (let i = 0; i < data.length; i++) {
                            let newObj: AttachmentBus = new AttachmentBus(data[i]);
                            att.push(newObj);
                        }
                    }
                    this.attachments = att;
                    this.attachmentsLoading = false;
                });
            }
        }
  }
    getErrors(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            if (this.svc_data) {
                this.errorsLoading = true;
                CommonFunctions.unsubscribe(this.subs_errors);
                this.subs_errors = this.svc_data.getOrderErrors(id).subscribe(data => {
                    let arr = [];
                    if (CommonFunctions.hasArrayValue(data)) {
                        for (let i = 0; i < data.length; i++) {
                            let newObj: DQOIErrorBus = new DQOIErrorBus(data[i]);
                            arr.push(newObj);
                        }
                    }
                    this.errors = arr;
                    this.errorsLoading = false;
                });
            }
        }

    }
    getNotes(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            if (this.svc_data) {
                this.notesLoading = true;
                CommonFunctions.unsubscribe(this.subs_notes);
                this.subs_notes = this.svc_data.getOrderNotes(id).subscribe(data => {
                    let arr = [];
                    if (data && CommonFunctions.hasArrayValue(data.primaryReturn)) {
                        for (let i = 0; i < data.primaryReturn.length; i++) {
                            let newObj: OrderNotesBus = new OrderNotesBus(data.primaryReturn[i]);
                            arr.push(newObj);
                        }
                    }
                    this.notes = arr;
                    this.notesLoading = false;
                });
            }
        }

    } 
    getStatusHistory(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.statusHistoryLoading = true;
            CommonFunctions.unsubscribe(this.subs_statusHistory);
            this.subs_statusHistory = this.svc_data.getOrderStatusHistory(id).subscribe(data => {
                this.statusHistory = data;
                this.statusHistoryLoading = false;
            });
        }
    }
  
  id: any;
  attachments: AttachmentBus[];
    errors: DQOIErrorBus[]; 
    notes: OrderNotesBus[];
  statusHistory: StatusHistoryBus[];
    attachmentsLoading: boolean = false;
    errorsLoading: boolean = false;
    notesLoading: boolean = false;
    statusHistoryLoading: boolean = false;
  
  get hasAttachments(): boolean {
    return CommonFunctions.hasValue(this.attachments) || this.attachmentsLoading;
  }
  get hasErrors(): boolean {
      return CommonFunctions.hasValue(this.errors) || this.errorsLoading;
    }
    get hasNotes(): boolean {
        return CommonFunctions.hasValue(this.notes) || this.notesLoading;
    }
    get hasStatusHistory(): boolean {
        return CommonFunctions.hasValue(this.statusHistory) || this.statusHistoryLoading;
    }
}
